import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie as CookieIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem("incipit-cookie-consent")) setVisible(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const decide = (choice) => {
        localStorage.setItem("incipit-cookie-consent", choice);
        localStorage.setItem("incipit-cookie-consent-at", new Date().toISOString());
        setVisible(false);
    };

    if (!visible) return null;
    return (
        <div className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:max-w-md z-[60] bg-card border border-border rounded-xl shadow-2xl p-5 animate-fade-up" data-testid="cookie-banner">
            <div className="flex items-start gap-3">
                <CookieIcon className="text-primary shrink-0 mt-0.5" size={22} />
                <div>
                    <h4 className="font-semibold">Rispettiamo la tua privacy</h4>
                    <p className="text-sm text-muted-foreground mt-1 leading-relaxed">
                        Utilizziamo cookie tecnici necessari al funzionamento del sito. Puoi accettare tutti i cookie
                        o limitarti a quelli essenziali. Dettagli nella{" "}
                        <Link to="/cookie" className="text-primary underline">Cookie Policy</Link>.
                    </p>
                    <div className="flex gap-2 mt-4">
                        <Button size="sm" onClick={() => decide("accepted")} className="bg-primary hover:bg-primary/90" data-testid="cookie-accept">Accetta tutti</Button>
                        <Button size="sm" variant="outline" onClick={() => decide("essential")} data-testid="cookie-reject">Solo necessari</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
